import firebase from "firebase";

export const send = async (to, message, params) => {
  console.log(to, message, params);
  let callable = firebase.functions().httpsCallable("sendSmsMessage");
  return callable({ ...params, body: message, to }).then(result => result.data);
};
export const schedule = async ({ to, body, category, type, tag, time }) => {
  let callable = firebase.functions().httpsCallable("scheduleSmsMessage");
  return callable({ to, body, category, type, tag, time }).then(
    result => result.data
  );
};
export const sendBulk = async (recipients, message) => {
  let callable = firebase.functions().httpsCallable("sendBulkMessages");
  return callable({ recipients, message }).then(result => result.data);
};
export const sendGroupMessage = async groupId => {
  let callable = firebase.functions().httpsCallable("sendSmsGroupMessage");
  return callable(groupId).then(result => result.data);
};
export const dispatchCampaign = async campaignId => {
  let callable = firebase.functions().httpsCallable("dispatchSmsCampaign");
  return callable(campaignId).then(result => result.data);
};
export const sendCampaign = async campaignId => {
  let callable = firebase.functions().httpsCallable("sendSmsCampaign");
  return callable(campaignId).then(result => result.data);
};
